var map = {
	"./colorpicker.png": 677,
	"./discord.png": 1017,
	"./fb.png": 1018,
	"./google.png": 1019,
	"./pay-qiwi.png": 1020,
	"./pay-yandex.png": 1021,
	"./steam_logo.png": 1022,
	"./vk.png": 1023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 308;